<template>
  <vx-card title="Zahlungsarten">
    <vue-apex-charts
      v-if="series.length"
      type="donut"
      height="300"
      :options="chartOptions"
      :series="series"
    />
    <p v-else class="text-grey text-center py-4">Keine Daten vorhanden</p>
    <div v-if="paymentData" class="mt-4 pt-4 border-t">
      <p class="text-sm text-grey">
        Abgebrochene Zahlungen (Online):
        {{ (paymentData.failedRate * 100).toFixed(1) }}% ({{
          paymentData.failedOrders
        }}
        von {{ paymentData.totalNonCash }})
      </p>
    </div>
  </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "AnalyticsPaymentMethods",
  components: { VueApexCharts },
  computed: {
    paymentData() {
      return this.$store.state.analytics.paymentMethods;
    },
    distribution() {
      return this.paymentData ? this.paymentData.distribution : [];
    },
    series() {
      return this.distribution.map((d) => d.count);
    },
    chartOptions() {
      return {
        chart: { foreColor: "#c2c6dc", background: "transparent" },
        theme: { mode: "dark" },
        labels: this.distribution.map((d) => this.formatLabel(d._id)),
        colors: ["#C41E2A", "#2ECC71", "#E74C3C", "#27AE60", "#1E1E1E"],
        fill: { opacity: 0.85 },
        stroke: { colors: ["rgba(255,255,255,0.08)"], width: 2 },
        legend: { position: "bottom" },
        dataLabels: { enabled: true },
      };
    },
  },
  methods: {
    formatLabel(method) {
      const labels = {
        bar: "Bar",
        "bar(app)": "Bar (App)",
        paypal: "PayPal",
        stripe: "Stripe",
        braintree: "Braintree",
      };
      return labels[method] || method;
    },
  },
};
</script>
